
// Keep the hidden variant-id <select> in sync with the option <select>s so the
// correct variant (price + SKU) is added to cart. Works with the product form.
document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('.product form');
  if (!form) return;
  var optionSelects = form.querySelectorAll('.vselect');
  var idSelect = form.querySelector('.variant-id-select');
  var priceEl = document.getElementById('price');
  if (!optionSelects.length || !idSelect) return;

  function chosenTitle() {
    return Array.prototype.map.call(optionSelects, function (s) { return s.value; }).join(' / ');
  }
  function sync() {
    var want = chosenTitle();
    Array.prototype.forEach.call(idSelect.options, function (opt) {
      if (opt.textContent.trim().indexOf(want) === 0) {
        idSelect.value = opt.value;
        if (priceEl) {
          var m = opt.textContent.split('—')[1];
          if (m) priceEl.textContent = m.trim();
        }
      }
    });
  }
  Array.prototype.forEach.call(optionSelects, function (s) { s.addEventListener('change', sync); });
  sync();
});

// Homepage "Choose your size" filter chips
document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.getElementById('homeFilters');
  if (!wrap) return;
  var chips = wrap.querySelectorAll('.chip');
  var cards = document.querySelectorAll('#homeGrid .prod');
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      chips.forEach(function (x) { x.classList.remove('active'); });
      c.classList.add('active');
      var f = c.getAttribute('data-filter');
      cards.forEach(function (card) {
        var g = card.getAttribute('data-group');
        card.style.display = (f === 'all' || g === f) ? '' : 'none';
      });
    });
  });
});
